import {
  PAGE_TITLE_MAX_LENGTH,
  PAGE_URL_MAX_LENGTH,
  type PageContext,
} from "@hightouch/lib/agent-harness/shared/context-schema";

/** Read at send time: Helmet sets the title after render, so a published value can lag the page. */
export function readPageContext(): PageContext {
  return {
    url: window.location.href.slice(0, PAGE_URL_MAX_LENGTH),
    title: document.title.slice(0, PAGE_TITLE_MAX_LENGTH),
  };
}
